/**
 * Conversion and analytics event tracking utility.
 * Supports Google Ads, GTM dataLayer, and developer logging.
 */
export function trackEvent(eventName, params = {}) {
  if (typeof window !== 'undefined') {
    // Send to dataLayer if available
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: eventName,
        ...params,
        timestamp: new Date().toISOString(),
      });
    }

    // Console logging for verification
    if (import.meta.env.DEV) {
      console.log(`[Tracking Event] ${eventName}:`, params);
    }
  }
}

export const BOOKING_SCREENING_URL = 'https://book.palasz.dk/widget/booking/i2bNcPk3TnWm8BcRRUcN';
export const BOOKING_THERAPY_URL = 'https://book.palasz.dk/widget/group/uEgUEb3zGAuDg10zJ9L1';
export const BOOKING_SUPERVISION_URL = 'https://book.palasz.dk/widget/group/R7nXWKRaJg5Q2NikpAwi';
export const PHONE_NUMBER = '26 81 26 81';
export const PHONE_TEL = 'tel:+4526812681';
export const EMAIL_ADDRESS = 'kontakt@palasz.dk';
